import { get, del, put, post } from 'aws-amplify/api';
import { replaceNullsWithEmpty } from '../utils/utils';
import { Payment } from '../models/payment.model';
import { CreatePayment, CreatePaymentSchema } from '../models/createPayment.model';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getUserToken } from './util.service';

dayjs.extend(utc);

export const createPayment = async (createPayment: CreatePayment) => {
  const userToken = await getUserToken();

  const createPaymentBody = mapToRequest(createPayment);
  const response = await post({
    apiName: 'payments',
    path: '/payments',
    options: { body: createPaymentBody, headers: { 'x-auth-token': `Bearer ${userToken}` } },
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

export const getPayments = async (filters: {
  name?: string;
  status?: string;
  limit?: number;
  lastKey?: string;
}): Promise<{ items: PaymentItem[]; lastKey: string }> => {
  const limit = filters.limit ?? 25;
  const lastKey = filters.lastKey ?? '';
  const response = await get({
    apiName: 'payments',
    path: `/payments?limit=${limit}&lastKey=${lastKey}&status=${filters.status}&name=${filters.name}`,
  }).response;
  const json = (await response.body.json()) as any;
  return {
    items: json.items.map((a: any) => mapFromResponse(a)),
    lastKey: json.lastKey,
  };
};

export const getPayment = async (paymentId: string): Promise<Payment> => {
  const response = await get({ apiName: 'payments', path: `/payments/${paymentId}` }).response;
  const json = (await response.body.json()) as any;
  return mapFromResponse(json);
};

export const updatePayment = async (payment: Payment): Promise<void> => {
  const userToken = await getUserToken();

  await put({
    apiName: 'payments',
    path: `/payments/${payment.id}`,
    options: { body: mapToRequest(payment), headers: { 'x-auth-token': `Bearer ${userToken}` } },
  }).response;
};

export const deletePayment = async (paymentId: string): Promise<void> => {
  await del({ apiName: 'payments', path: `/payments/${paymentId}` }).response;
};

const mapFromResponse = (payment: any): Payment => {
  const res: Payment = {
    ...payment,
  };
  return replaceNullsWithEmpty(res);
};

const mapToRequest = (payment: CreatePayment | Payment): any => {
  const newPayment = { ...payment, dueDate: dayjs(payment.dueDate).utc().startOf('day').toDate() };
  const resParse = CreatePaymentSchema.safeParse(newPayment);
  if (resParse.success) {
    return resParse.data;
  }
  console.log(resParse.error);

  throw new Error('Validation error');
};
